"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var SimulationValue_1 = require("./SimulationValue");
/**
 * @author BPo
 */


var SimulationBigNumber =
/*#__PURE__*/
function (_SimulationValue_1$Si) {
  _inherits(SimulationBigNumber, _SimulationValue_1$Si);

  function SimulationBigNumber() {
    _classCallCheck(this, SimulationBigNumber);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulationBigNumber).apply(this, arguments));
  }

  _createClass(SimulationBigNumber, null, [{
    key: "fromSimulatedValue",
    value: function fromSimulatedValue(value) {
      return new SimulationBigNumber(value, null, null, null);
    }
    /**
     * Converter from data-dictionary representation
     */

  }, {
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SimulationBigNumber(mat.simulatedValue, mat.originalValue, mat.note, mat.accepted);
    }
  }]);

  return SimulationBigNumber;
}(SimulationValue_1.SimulationValue);

exports.SimulationBigNumber = SimulationBigNumber;

SimulationBigNumber.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimulationBigNumber.name);
  return {
    simulatedValue: builder.bigNum('simulatedValue'),
    originalValue: builder.opt(builder.bigNum('originalValue')),
    note: builder.opt(builder.str('note')),
    accepted: builder.opt(builder.bool('accepted'))
  };
}();